module.exports = __webpack_public_path__ + "static/media/web01_ch01.060fbed7.png";